import $ from 'jquery';

const SELECTOR = {
    CONTAINER_SUBLEVEL: '.rsp_nav__list',
    BREADCRUMB_CHANNEL_IDS_SELECTOR: '#breadcrumb-channel-ids',
    DATA_CHANNEL_ID_ATTR: "data-channelid"
};

const CLASS = {
    IS_ACTIVE: 'is-active',
};

export default class NavPanelMobile {

    constructor() {
        var _self = this;
        _self.$panel = $(SELECTOR.CONTAINER_SUBLEVEL);
        _self.$lvlLinks = _self.$panel.find("li.rsp_nav__item[data-channelid]");
        _self.currentChannelBreadcrumb = $(SELECTOR.BREADCRUMB_CHANNEL_IDS_SELECTOR).val();
    }
    /**
     * Init App
     */
    init() {
        var _self = this;
        _self.bindEvents();
        _self.setActiveLink();
    }

    /**
     * Bind required events
     */
    bindEvents() {

        $('.rsp_nav__item ul').hide();
		
        $('.rsp_btn.rsp_btn--burger.js-header-burger').on("click", function(){
            //$('.rsp_nav__item ul').slideUp();
            $('.rsp_nav__item ul').each(function(){
                if($(this).hasClass("rsp_menu-left_list")){
                    $(this).slideUp();
                }
            })
        });


        var allMenuBtns = $(".rsp_nav__item button.rsp_btn.rsp_btn--toggle.js-nav-mobile-first-lvl-btn");
        allMenuBtns.on("click",function(e) {
            e.stopPropagation();
			
			var $myListe = $(this).next('ul.rsp_nav__list');
			$(this).attr('aria-expanded', ($myListe.css('display') == 'none') ? 'true' : 'false');		
            $myListe.slideToggle();
			
            //var $myListe = $mainLI.find("ul.rsp_nav__list.js-nav-mobile-second-lvl-container");
            //$myListe.addClass('is-show'); // ?!
			
			// If main : close others
			if (!$(this).hasClass("rsp_btn--sub-level")) {
				var $mainLI = $(this).closest("li");
				var $allMainLI = $mainLI.siblings();
				$allMainLI.find("ul.rsp_nav__list.js-nav-mobile-second-lvl-container").slideUp("100");
				$allMainLI.find("button.rsp_btn.js-nav-mobile-first-lvl-btn").each(function(){
					if(!$(this).hasClass("rsp_btn--sub-level")){
						$(this).attr('aria-expanded','false'); //rsp_btn--toggle. & rsp_btn--emergency
					}
				})
			}
        });


        //var subMenu = $("button.rsp_btn.rsp_btn--toggle.rsp_btn--sub-level.js-nav-mobile-first-lvl-btn");
        //subMenu.on("click",function(e) {
			
		//	var $myListe = $(this).next('ul.rsp_nav__list');
		//	$(this).attr('aria-expanded', ($myListe.css('display') == 'none') ? 'true' : 'false');		
        //    $myListe.slideToggle();
          //  //$(this).parent("ul.rsp_nav__list.js-nav-mobile-second-lvl-container").show();
        //});


        //var subMenu2 = $("button.rsp_btn.rsp_btn--toggle.rsp_btn--sub-level.pl-3.js-nav-mobile-first-lvl-btn");
        //subMenu2.on("click",function(e) {
        //    $(this).next('ul.rsp_nav__list.rsp_nav__list--lvl3').show();
        //    $(this).parents("ul.rsp_nav__list.js-nav-mobile-second-lvl-container").show();
        //});
		

        var otherSite = $("button.rsp_btn.rsp_btn--emergency.js-nav-mobile-first-lvl-btn");
        otherSite.on("click",function(e) {
            let attrSwitch = $(this).attr('aria-expanded');
            $(this).attr('aria-expanded', (attrSwitch === 'false') ? 'true' : 'false');
            $(this).next('#sub-list-otherSite_metiers, #sub-list-otherSite_regions').slideToggle();
        });
    }

    setActiveLink() {
        var _self = this;

        if (_self.currentChannelBreadcrumb != undefined) {
            // perform first lvl
            if (_self.$lvlLinks.length > 0) {
                _self.activateLinkWithChannelId(_self.$lvlLinks);
            }
        }
    }

    activateLinkWithChannelId($listLinks) {
        var _self = this;
        var currentChannelIds = _self.currentChannelBreadcrumb;

        $listLinks.each(function(index, element) {
            var currentChannelId = $(element).attr(SELECTOR.DATA_CHANNEL_ID_ATTR);
            if (currentChannelId !== "" && currentChannelIds.indexOf(currentChannelId) >= 0) {
                _self.$firstLinkActive = $(element);
                _self.$firstLinkActive.addClass(CLASS.IS_ACTIVE);
                //_self.$firstLinkActive.parents("ul[class='rsp_nav__list']").each(function(){
				//	$(this).show();
				//	$(this).prev().attr('aria-expanded','true');
				//});
				
				// Open menu
                _self.$firstLinkActive.parents("ul.rsp_nav__list").each(function(){
					$(this).show();
					$(this).prev("button").attr('aria-expanded','true');
				});

                _self.$firstLinkActive.children("a").attr('aria-current','page');

                //_self.$firstLinkActive.parent("ul.rsp_nav__list").show();
                //_self.$firstLinkActive.parents(".rsp_nav__list.js-nav-mobile-second-lvl-container").show();
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/header/lhs/auth/navPanelMobile.js